// Existing scalar overrides are preserved as undated baselines; course prices
// are suggestions only. Revisions never rewrite earlier receipts or agreements.
function studentFee(student, kind, month) {
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(month || '')) return { amount: null, source: 'unknown' };
  const revisions = (student.feeRevisions || []).filter(row => row.kind === kind && row.effectiveMonth <= month && (!row.singleMonth || row.effectiveMonth === month))
    .sort((a, b) => b.effectiveMonth.localeCompare(a.effectiveMonth));
  if (revisions.length) return { amount: revisions[0].amount, source: 'revision', effectiveMonth: revisions[0].effectiveMonth };
  const amount = kind === 'monthly' ? student.specialMonthlyFee : student.admissionFee;
  return typeof amount === 'number' && Number.isFinite(amount) && amount >= 0
    ? { amount, source: 'baseline' } : { amount: null, source: 'unknown' };
}
export { studentFee };

function admissionFeeMonth(student) {
  if (/^\d{4}-(0[1-9]|1[0-2])$/.test(student.monthlyStartMonth || '')) return student.monthlyStartMonth;
  if (!student.joinDate) return '';
  const date = new Date(student.joinDate);
  return Number.isFinite(date.getTime()) ? new Date(date.getTime() + 330 * 60000).toISOString().slice(0, 7) : '';
}
export { admissionFeeMonth };
